import { render, staticRenderFns } from "./Chrome.vue?vue&type=template&id=31f95fb0&"
import script from "./Chrome.vue?vue&type=script&lang=js&"
export * from "./Chrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports